import {
  Component,
  OnInit,
  OnDestroy,
  Input
} from '@angular/core';

@Component({
    selector: 'app-permutation-chart-component',
    templateUrl: './permutation-chart.component.html',
    styleUrls: ['./permutation-chart.component.scss'],
    standalone: false
})
export class PermutationChartComponent implements OnInit, OnDestroy {
  @Input() testData;
  @Input() tSCount;
  wireData: any = [];

  constructor() {}

  ngOnInit() {
    this.initialize();
  }

  initialize() {
    this.wireData = JSON.parse(this.testData);
    for (let i = 0; i < this.wireData.length; i++) {
      this.wireData[i] = this.wireData[i].filter(x => x);
    }
  }

  ngOnDestroy() {}
}
